import { render } from "./EducationInfo.vue?vue&type=template&id=3cea73fa&scoped=true"
import script from "./EducationInfo.vue?vue&type=script&lang=js"
export * from "./EducationInfo.vue?vue&type=script&lang=js"

import "./EducationInfo.vue?vue&type=style&index=0&id=3cea73fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cea73fa"]])

export default __exports__